import { getNoContentApiClient } from 'adapter/out/client/apiClient';
import DeleteReportInstanceCriteria from 'use-case/reportInstance/delete/deleteReportInstanceCriteria';

const deleteReportInstanceApiClient = getNoContentApiClient(
    (criteria: DeleteReportInstanceCriteria) => `dashboards/reports/${criteria.reportInstanceId}`,
    () => ({
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
    })
);

export default deleteReportInstanceApiClient;
